import { render, staticRenderFns } from "./SpaceStatusChart.vue?vue&type=template&id=6cbffad3"
import script from "./SpaceStatusChart.vue?vue&type=script&lang=js"
export * from "./SpaceStatusChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports